<template>
  <div class="ui modal rokus360-popup" ref="modal">
    <button
      class="close-button ui button"
      @click.stop="closePopup"
      aria-label="Zapri"
    >
      <!-- X icon -->
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2807 18.2194C19.3504 18.289 19.4056 18.3718 19.4433 18.4628C19.4811 18.5539 19.5005 18.6514 19.5005 18.75C19.5005 18.8485 19.4811 18.9461 19.4433 19.0372C19.4056 19.1282 19.3504 19.2109 19.2807 19.2806C19.211 19.3503 19.1283 19.4056 19.0372 19.4433C18.9462 19.481 18.8486 19.5004 18.7501 19.5004C18.6515 19.5004 18.5539 19.481 18.4629 19.4433C18.3718 19.4056 18.2891 19.3503 18.2194 19.2806L12.0001 13.0603L5.78068 19.2806C5.63995 19.4213 5.44907 19.5004 5.25005 19.5004C5.05103 19.5004 4.86016 19.4213 4.71943 19.2806C4.5787 19.1399 4.49963 18.949 4.49963 18.75C4.49963 18.551 4.5787 18.3601 4.71943 18.2194L10.9397 12L4.71943 5.78061C4.5787 5.63988 4.49963 5.44901 4.49963 5.24999C4.49963 5.05097 4.5787 4.8601 4.71943 4.71936C4.86016 4.57863 5.05103 4.49957 5.25005 4.49957C5.44907 4.49957 5.63995 4.57863 5.78068 4.71936L12.0001 10.9397L18.2194 4.71936C18.3602 4.57863 18.551 4.49957 18.7501 4.49957C18.9491 4.49957 19.1399 4.57863 19.2807 4.71936C19.4214 4.8601 19.5005 5.05097 19.5005 5.24999C19.5005 5.44901 19.4214 5.63988 19.2807 5.78061L13.0604 12L19.2807 18.2194Z"
          fill="#212529"
        />
      </svg>
    </button>

    <img src="/images/popup/rokus360.webp" alt="Rokus360" />

    <div class="content">
      <div class="title">Na voljo je Rokus360</div>

      <div class="text">
        <div>
          Za vas smo pripravili novo enotno digitalno učno okolje Rokus360, ki
          na enem mestu združuje učna gradiva, interaktivne vsebine in digitalna
          orodja za učitelje, učence in starše.
        </div>
        <div>
          Portalov iRokus.si, iRokusPlus.si, IzziRokus.si, Lilibi.si,
          Svet-Lilibi.si, Radovednih-pet.si, Planet.Radovednih-pet.si in
          Znamzavec.si ne posodabljamo več in bodo postopoma ukinjeni.
        </div>
      </div>

      <div class="actions">
        <button class="ui yellow basic button" @click.stop="closePopup">
          Zapri
        </button>
        <a
          class="ui yellow button"
          href="https://rokus360.si"
          target="_blank"
          @click="closePopup"
        >
          Spoznaj Rokus360<span class="icon-box" aria-hidden="true">
            <i class="fas fa-arrow-right"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import popup from "./Popup.vue";

export default {
  mixins: [popup],
  props: ["data"],
  methods: {
    closePopup() {
      this.$root.$emit("close-popup", this);
      $(this.$refs["modal"]).modal("hide");
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/PopupRokus360.vue